import { Box } from '@/components/Box/Box';
import { BankName, CardInfo, CardWrapper } from './styles';
import { ButtonNew } from '@/components-new/ButtonNew/ButtonNew';
import { Typography } from '@/components/Typography/Typography';
import { VaultAccountType } from '@/types/myVaultTypes';
import { formatDate, FULL_MONTH_DATE_FORMAT } from '@/helpers/dateHelpers/dateHelpers';
import { VaultAccountStatus } from '../VaultAccountStatus';
import { Mono } from '@/styles/common';

type ClosedVaultCardType = {
  account: VaultAccountType;
  onReopen: () => void;
};

export const ClosedVaultCard = ({ account, onReopen }: ClosedVaultCardType) => {
  const { nickname, bank_name, status, country, masked_number, closed_at, record_hash_short, initials } = account;

  const date = formatDate(closed_at, FULL_MONTH_DATE_FORMAT);

  const reopen = () => {
    onReopen();
  };

  return (
    <CardWrapper>
      <CardInfo noRatio>
        <BankName closed>{initials}</BankName>

        <Box display='flex' flexDirection='column' gap='4px' alignItems='flex-start'>
          <Box display='flex' justifyContent='center' gap='12px' alignItems='center'>
            <Typography fontWeight='semibold'>{nickname}</Typography>
            <VaultAccountStatus status={status}></VaultAccountStatus>
          </Box>
          <Typography variant='bodySmall'>
            {bank_name} · {country} · <Mono>{masked_number}</Mono>
          </Typography>
          <Typography variant='bodySmall'>
            Record <Mono>{record_hash_short || '-'}</Mono> · closed {date}
          </Typography>
        </Box>
      </CardInfo>

      <Box display='flex' gap={'12px'} marginLeft={'auto'} alignItems='center'>
        <ButtonNew variant='secondary' onClick={reopen}>
          Reopen
        </ButtonNew>
      </Box>
    </CardWrapper>
  );
};
